import { formatPercentage } from "../EditablePercentage/EditablePercentage.jsx";
import { effectiveValue } from "../../domain/document.js";
import { propertyHref } from "../PropertyIdentity/PropertyIdentity.jsx";
import { propertyValueHref } from "../PropertyValueIdentity/PropertyValueIdentity.jsx";
import "./AssetDecorations.css";

export function AssetDecorations({ allocationBasisPoints = null, assetId, document, propertyIds }) {
  const properties = propertyIds.map((propertyId) => document.properties.find((property) => property.id === propertyId)).filter(Boolean);
  if (!properties.length && allocationBasisPoints === null) return null;

  return <dl className="asset-decorations">{properties.map((property) => {
    const value = effectiveValue(document, assetId, property.id);
    return <div key={property.id}><dt><a href={propertyHref(property.id)}>{property.name}</a>:</dt><dd><a href={propertyValueHref(property.id, value.id)}>{value.name}</a></dd></div>;
  })}{allocationBasisPoints !== null ? <div><dt>Allocation:</dt><dd>{formatPercentage(allocationBasisPoints)}%</dd></div> : null}</dl>;
}
